import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import CircleChart from './Circle';
import { KeyValueProps } from '../../../types/Common';
import PriorityBox from './PriorityBox';
import { typeMappingHandler } from '../../../constants/keysMapping';
import './job.scss';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none',
    paddingTop: '0.5rem',
  },

  accordionSummaryRoot: {
    padding: '0 !important',
    minHeight: '1rem !important',
  },

  accordionSummaryContent: {
    margin: '0 !important',
  },

  accordionDetailsRoot: {
    padding: '0',
  },
}));

interface JobGroupsProps {
  sortJobGroupArray: KeyValueProps[];
  maxKeyJobGroup: string;
  setMaxKeyJobGroup: (maxKeyJobGroup: string) => void;
  skils: any;
}

const JobGroups: React.FC<JobGroupsProps> = (props) => {
  const { sortJobGroupArray, maxKeyJobGroup, skils, setMaxKeyJobGroup } = props;
  const { SG1, SG2, SG3, SG4 } = skils || {};
  const isMobile = useMediaQuery('(max-width:991px)');
  const styles = useStyles();
  const [expanded, setExpanded] = useState<boolean>(true);

  const sg1Array = Object.entries(SG1).map((item: any) => {
    return {
      key: item[0],
      value: Math.floor(item[1] * 1000000),
    };
  });

  const sg2Array = Object.entries(SG2).map((item: any) => {
    return {
      key: item[0],
      value: Math.floor(item[1] * 1000000),
    };
  });

  const sg3Array = Object.entries(SG3).map((item: any) => {
    return {
      key: item[0],
      value: Math.floor(item[1] * 1000000),
    };
  });

  const sg4Array = Object.entries(SG4).map((item: any) => {
    return {
      key: item[0],
      value: Math.floor(item[1] * 1000000),
    };
  });

  const handelChange = () => setExpanded((prevState) => !prevState);

  return (
    <Grid container className='gridContainer'>
      <Grid item lg={6} md={12} sm={12} xs={12} p={2}>
        <Typography color='text.dark' fontWeight='bold'>
          گروه های شغلی مناسب
        </Typography>

        <Box className='priorityContainer'>
          <Typography fontWeight='lighter' noWrap>
            اولویت اول شما
          </Typography>
          <PriorityBox index={1} label={typeMappingHandler(maxKeyJobGroup).message} fullWidth />
        </Box>

        <Accordion classes={{ root: styles.root }} expanded={expanded} onChange={handelChange}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color='action' />}
            aria-controls='panel1-content'
            id='panel1-header'
            classes={{ root: styles.accordionSummaryRoot, content: styles.accordionSummaryContent }}
          >
            <Typography fontWeight='lighter'>اولیت های بعدی شما</Typography>
          </AccordionSummary>
          <AccordionDetails classes={{ root: styles.accordionDetailsRoot }}>
            <Grid container>
              {sortJobGroupArray.map((item, index) => {
                const { key } = item || {};
                return (
                  <Grid
                    item
                    xl={4}
                    lg={6}
                    md={4}
                    xs={6}
                    key={index.toString()}
                    p={isMobile ? 0.5 : 1}
                  >
                    <PriorityBox
                      index={index + 1}
                      label={typeMappingHandler(key).message}
                      fullWidth
                      onClick={() => setMaxKeyJobGroup(key)}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>

      <Grid item lg={6} md={12} sm={12} xs={12} p={2}>
        <Box className='spaceBetween'>
          <Typography color='text.dark' fontWeight='bold'>
            توسعه فردی
          </Typography>
          <Typography color='primary.dark' fontSize='small' noWrap>
            نمودار ها بر اساس تست شما هستند
          </Typography>
        </Box>

        <CircleChart sg1={sg1Array} sg2={sg2Array} sg3={sg3Array} sg4={sg4Array} />
      </Grid>
    </Grid>
  );
};

export default JobGroups;
